import { useCallback, useEffect, useState } from 'react';
import { auditApi, facilityApi } from '../../api/api';
import AuditLogTable from '../facility/AuditLogTable';

export default function AdminAuditPanel() {
    const [facilities, setFacilities] = useState([]);
    const [facilityId, setFacilityId] = useState('');

    useEffect(() => {
        let live = true;
        facilityApi.list()
            .then((list) => { if (live) setFacilities(list || []); })
            .catch(() => { if (live) setFacilities([]); });
        return () => { live = false; };
    }, []);

    const load = useCallback(
        (params) => auditApi.listAll(facilityId ? { ...params, facility_id: facilityId } : params),
        [facilityId],
    );

    return (
        <div className="admin-audit">
            <label className="audit-log-field" style={{ padding: '12px 20px 0', maxWidth: 320 }}>
                <span>Facility</span>
                <select value={facilityId} onChange={(e) => setFacilityId(e.target.value)}>
                    <option value="">All facilities</option>
                    {facilities.map((f) => (
                        <option key={f.id} value={f.id}>{f.name || f.id}</option>
                    ))}
                </select>
            </label>
            <AuditLogTable key={facilityId} load={load} showFacility={!facilityId} />
        </div>
    );
}
